import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { BiTrackService } from '@eureka/domains/src/bi-track/services/bi-track-service';
import { EurekaTrackEventType } from '@eureka/domains/src/bi-track/types';
import { openModuleSourcesDrawer } from '@/composables/use-project-report-reference';
import type { CatalogItem } from '@/types';

/**
 * 报告模块查看来源的通用逻辑
 */
export function useReportViewSources() {
    const biTrackService = injectService<BiTrackService>(BiTrackService);

    const handleViewSources = (task: CatalogItem) => {
        openModuleSourcesDrawer(task.module_type, task.task_group_type);

        biTrackService.biTrack(EurekaTrackEventType.QUICK_RESEARCH, {
            sourceType: 'link',
            otherParam: task.task_group_type,
        });
    };

    return {
        handleViewSources,
    };
}
